import { SlingoAnimationSpine } from "@lib/titan2-slingo/dist/game/view/abstract/display/SlingoAnimation";
export class GameSlingoAnimation extends SlingoAnimationSpine {
    playAnimation(numberOfSlingos) {
        super.playAnimation(numberOfSlingos);
        this.animation.getSpine().update(0.01);
        this.animation.setSpeed(1 / 0.85);
    }
}
//# sourceMappingURL=GameSlingoAnimation.js.map